import request from '@/utils/request'
class parent {
    // /khb/deleteKhbById/{id}
    delku(id) {
        return request({
            url: `/khb/deleteKhbById/${id}`,
            method: 'get'
        })
    }
    // /khb/queryKhbInfoByZtid
    querykh() {
        return request({
            url: '/khb/queryKhbInfoByZtid',
            method: 'get'
        })
    }
    //  /khb/updateKhbById
    updatekh(data) {
        return request({
            url: '/khb/updateKhbById',
            method: 'post',
            data: data
        })
    }
    ///khb/queryAllKhbInfo
    queryAllKhbInfo(data) {
        return request({
            url: '/khb/queryAllKhbInfo',
            method: 'post',
            data: data
        })
    }
    //最高管理员修改/khb/updateAllKhb
    updateAllKhb(data) {
        return request({
            url: '/khb/updateAllKhb',
            method: 'post',
            data: data
        })
    }
    ///khb/deleteKhbById/{id}/{ztid}
    deleteKhbById(id, ztid) {
        return request({
            url: `/khb/deleteKhbById/${id}/${ztid}`,
            method: 'get',
        })
    }
}
let item = new parent()

export default item